import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { tap, map } from 'rxjs/operators'
import { HeaderBasicAuthorizationService } from '../../../../../shared/services/header-basic-authorization.service';
import { JwtService } from '../../../../../shared/services/jwt.service';
import { StorageService } from '../../../../../shared/services/storage.service';
import { environment } from '../../../../../../environments/environment';
import { ApiEnum } from '../../../../../shared/enums/api.enum';
import { StorageKeyEnum } from '../../../../../shared/enums/storage-key.enum';
import { PermissionNavigationService } from '../../../../../shared/services/permission-navigation.service';
@Injectable({
    providedIn: 'root'
})
export class AuthService {

    constructor(private router: Router,
        private storageService: StorageService,
        private jwtService: JwtService,
        private httpClient: HttpClient,
        private headerBasicAuthorization: HeaderBasicAuthorizationService,
        private permissionNavigationService: PermissionNavigationService) { }

    login(login: string, password: string) {
        return this.httpClient.post(`${environment.api.WS_IT.url}/Seguridad/ZITG_Login`,
            {
                login: login,
                password: password
            }, {
            headers: this.headerBasicAuthorization.get(ApiEnum.WS_IT)
        }
        )
            .pipe(
                tap((response: any) => {
                    if (response.Ok) {
                        this.storageService.set(StorageKeyEnum.JWT_AUTHORIZATION, response.JWT);
                        this.storageService.set(StorageKeyEnum.UsuarioID, response.UsuarioID);
                        this.storageService.set(StorageKeyEnum.Nombre, response.Nombre);
                        this.storageService.set(StorageKeyEnum.Email, response.Email);
                        this.storageService.set(StorageKeyEnum.Login, response.Login);
                        this.storageService.set(StorageKeyEnum.DocIdentidad, response.DocIdentidad);
                        this.jwtService.load(response.JWT);
                    }
                })
            )
    }

    logoff() {
        this.permissionNavigationService.reset();
        this.storageService.remove(StorageKeyEnum.JWT_AUTHORIZATION);
        this.storageService.remove(StorageKeyEnum.UsuarioID);
        this.storageService.remove(StorageKeyEnum.Nombre);
        this.storageService.remove(StorageKeyEnum.Email);
        this.storageService.remove(StorageKeyEnum.Login);
        this.storageService.remove(StorageKeyEnum.DocIdentidad);
        this.jwtService.clear();
    }

    refreshToken() {
        return this.httpClient.get(`${environment.api.WS_IT.url}/Seguridad/refreshToken`, {
            headers: this.headerBasicAuthorization.get(ApiEnum.WS_IT)
        }).pipe(
            tap((response: any) => {
                if (response.Ok) {
                    this.storageService.set(StorageKeyEnum.JWT_AUTHORIZATION, response.JWT);
                    this.jwtService.load(response.JWT);
                }
            })
        );
    }

    forgotPassword(dominio: string, email: string, login: string) {
        return this.httpClient.post(`${environment.api.WS_IT.url}/Seguridad/ForgotPassword`,
            {
                dominio: dominio,
                email: email,
                login: login
            }, {
            headers: this.headerBasicAuthorization.get(ApiEnum.WS_IT)
        }
        )
    }

    changePassword(passwordActual: string, passwordNueva: string) {
        return this.httpClient.post(`${environment.api.WS_IT.url}/Seguridad/ChangePassword`,
            {
                passwordActual: passwordActual,
                passwordNueva: passwordNueva
            }, {
            headers: this.headerBasicAuthorization.get(ApiEnum.WS_IT)
        }
        )
    }

    resetPassword(Usuario:number, Password: string, PasswordToChange: string, RePasswordToChange: string) {
        return this.httpClient.post(`${environment.api.WS_IT.url}/Seguridad/ResetPassword`, 
            {
                Usuario: Usuario,
                Password: Password,
                PasswordToChange: PasswordToChange,
                RePasswordToChange : RePasswordToChange
            }, {
            headers: this.headerBasicAuthorization.get(ApiEnum.WS_IT)
        }
        )
    }


    findPermisosRoot() {
        return ['/', '/profile', '/change-password'];
    }

    findPermissions() {
        return this.httpClient.get(`${environment.api.WS_IT.url}/Seguridad/GetPermissions`, {
            params: {
            },
            headers: this.headerBasicAuthorization.get(ApiEnum.WS_IT)
        });
    }

    findPermisos(application: string) {
        return this.httpClient.get(`${environment.api.WS_IT.url}/ZITG_ObtenerOpcionesUsuario`, {
            params: {
                prmstrApplication: application
            },
            headers: this.headerBasicAuthorization.get(ApiEnum.WS_IT)
        });
    }

    isLoggedIn() {
        let jwt: string = this.storageService.get(StorageKeyEnum.JWT_AUTHORIZATION);
        if (jwt != null) {
            this.jwtService.load(jwt);
            return this.jwtService.isValid();
        } else {
            return false;
        }
    }

    redirectToLogin() {
        this.router.navigate(['/login']);
    }

    redirectToMain() {
        this.router.navigate(['/']);
    }

    redirectToNotAllowed() {
        this.router.navigate(['/error/not-allowed']);
    }

}